import React from 'react';
const bonuses = [{
  id: 1,
  title: 'Aromaterapia Fácil en 7 Minutos',
  desc: 'Aprende a crear aceites esenciales naturales desde cero',
  img: 'https://cdn.magicpatterns.com/uploads/wf34WZwzegnU2MgkRv7SV5/AROMATERAPIA_FACIL.webp'
}, {
  id: 2,
  title: 'Baños Mágicos y Sahumerios',
  desc: 'Guía práctica de limpieza y rituales ancestrales',
  img: 'https://cdn.magicpatterns.com/uploads/oiy8qjbAqG1Ui6z71CRPgX/Banos_Magicos_Transformadores.webp'
}, {
  id: 3,
  title: 'SOS 7 Días Antiinflamación',
  desc: 'Menú completo para desinflamar tu cuerpo',
  img: 'https://cdn.magicpatterns.com/uploads/aYaRFMpwuDsK7Nm2AePYGm/SOS_7_DIAS.webp'
}, {
  id: 4,
  title: 'Guía Herbal para la Mujer Radiante',
  desc: 'Bienestar femenino y equilibrio natural',
  img: 'https://cdn.magicpatterns.com/uploads/sDx79zeJjTx1f6kJ76uanH/GUIA_HERBAL_FEMENINA.webp'
}, {
  id: 5,
  title: 'Botiquín Natural Infantil',
  desc: 'Alternativas naturales y responsables para el hogar',
  img: 'https://cdn.magicpatterns.com/uploads/rrxu6kGrB9Qy3pCWXPubeJ/5.png'
}, {
  id: 6,
  title: 'Conservá Tus Hierbas',
  desc: 'Cómo guardar y conservar hierbas correctamente',
  img: 'https://cdn.magicpatterns.com/uploads/ec3GYcS3R4sUmRsRJTdCQU/ChatGPT_Image_19_may_2026,_00_39_10.png'
}, {
  id: 7,
  title: 'Belleza Herbal: Piel, Pelo y Manos',
  desc: 'Recetas naturales para tu rutina de belleza',
  img: 'https://cdn.magicpatterns.com/uploads/nEvctWWo9Ez7KpJgTTGXNH/D_NQ_NP_813254-MLA27526982086_062018-O.webp'
}, {
  id: 8,
  title: 'Cocina en 10 Minutos',
  desc: 'Comidas naturales fáciles y rápidas',
  img: 'https://cdn.magicpatterns.com/uploads/5k8DA7gibM3jLKe5PhNf2m/71ciABA45HL._UF1000,1000_QL80_.jpg'
}, {
  id: 9,
  title: 'Protocolo Express por Síntoma',
  desc: '"Me pasa esto → hago esto"',
  img: 'https://cdn.magicpatterns.com/uploads/49xAt2SEQSW3KeQj7uVooq/PROTOCOLOS_EXPRESS.webp'
}, {
  id: 10,
  title: 'Kit de Urgencias Naturales',
  desc: 'Soluciones rápidas para problemas comunes',
  img: 'https://cdn.magicpatterns.com/uploads/pRdS4pB3JbeTFGu7vht2kX/KIT_DE_URGENCIA.webp'
}];
export function Bonuses() {
  return <section className="py-16 px-4 bg-white border-t-8 border-brand-red" data-id="element-15">
      <div className="max-w-5xl mx-auto" data-id="element-16">
        <div className="text-center mb-16" data-id="element-17">
          <h2 className="text-4xl md:text-6xl font-heading font-black text-brand-red mb-4 uppercase" data-id="element-18">
            🎁 PERO ESPERÁ… ESTO NO ES TODO
          </h2>
          <p className="text-2xl md:text-4xl font-bold bg-yellow-200 inline-block px-4 py-2 rounded-lg uppercase" data-id="element-19">
            HOY TAMBIÉN RECIBÍS 10 GUÍAS DIGITALES DE REGALO
          </p>
          <p className="text-xl mt-6 font-bold text-gray-600" data-id="element-20">
            (Estos bonos son{' '}
            <span className="text-brand-red uppercase" data-id="element-21">GRATIS</span> solo por el
            día de hoy)
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-22">
          {bonuses.map(bonus => <a key={bonus.id} href="https://impulsodigital.vip/cart/44742359646294:1" className="bg-gray-50 rounded-2xl overflow-hidden shadow-lg border border-gray-200 hover:shadow-xl transition-shadow group flex flex-col sm:flex-row" data-id="element-23">
              <div className="w-full sm:w-2/5 relative overflow-hidden" data-id="element-24">
                <img src={bonus.img} alt={bonus.title} className="w-full h-full object-cover aspect-square group-hover:scale-105 transition-transform duration-300" data-id="element-25" />
                <div className="absolute top-2 left-2 bg-brand-red text-white text-xs font-bold px-2 py-1 rounded uppercase" data-id="element-26">
                  Regalo {bonus.id}
                </div>
              </div>
              <div className="p-6 sm:w-3/5 flex flex-col justify-center" data-id="element-27">
                <h3 className="text-xl font-bold mb-2 text-black leading-tight" data-id="element-28">
                  {bonus.title}
                </h3>
                <p className="text-gray-600 font-medium flex items-start gap-2" data-id="element-29">
                  <span className="text-brand-green font-bold" data-id="element-30">👉</span>
                  {bonus.desc}
                </p>
                <p className="mt-4 text-sm font-bold text-brand-red line-through opacity-50" data-id="element-31">
                  Valor normal: $9.990
                </p>
                <p className="text-sm font-bold text-brand-green uppercase" data-id="element-32">
                  HOY: GRATIS
                </p>
              </div>
            </a>)}
        </div>
      </div>
    </section>;
}